import classNames from 'classnames';

import { ComboBox } from '../../Forms/AdvancedInputs/ComboBox';
import { Checkbox } from '../../Forms/Checkbox';
import { WithLightTitle } from '../../WithLightTitle';

import styles from './ComboBoxWithCheckbox.module.scss';
import { Props } from './ComboBoxWithCheckbox.types';

/** @deprecated use a combobox and checkboxes separately instead */
export const ComboBoxWithCheckbox = <T,>({
  comboId,
  comboSearchResults,
  comboKeyValueExtractor,
  comboBoxOnChange,
  comboBoxFetchStatus,
  comboBoxValue,
  comboBoxPlaceholder,
  comboBoxTitle,
  checkboxesData,
  checkboxesTitle,
  checkboxContainerClassName,
  containerClassName,
  isOptionEqualToValue,
}: Props<T>) => {
  return (
    <div className={classNames(styles.container, containerClassName)}>
      <WithLightTitle title={comboBoxTitle} className={styles.comboBox}>
        <ComboBox
          className={styles.comboBox}
          id={comboId}
          searchResults={comboSearchResults}
          useNativeOptionFiltering
          keyValueExtractor={comboKeyValueExtractor}
          onChange={comboBoxOnChange}
          fetchStatus={comboBoxFetchStatus}
          value={comboBoxValue}
          placeholder={comboBoxPlaceholder}
          isOptionEqualToValue={isOptionEqualToValue}
        />
      </WithLightTitle>
      <div>
        <WithLightTitle title={checkboxesTitle ?? ''}>
          <div className={styles.checkboxesContainer}>
            {checkboxesData.map((checkboxData, index) => {
              return (
                <div className={checkboxContainerClassName}>
                  <Checkbox
                    key={index}
                    label={checkboxData.label}
                    checked={checkboxData.checked}
                    onChange={checkboxData.onChange}
                  />
                </div>
              );
            })}
          </div>
        </WithLightTitle>
      </div>
    </div>
  );
};
